import React, { useState } from 'react'
import styles from './styles.module.scss'
import { TabsBlock } from '../../reusable/tabBlock'
import { SpecializedChatbot } from './components/ragChatbot'
import { StoredItems } from './components/storedItems'
import { useKnowledgeBase } from './hooks/useKnowledgeBase'

export const KnowledgeBaseView = () => {
    const [selectedTabIndex, setSelectedTabIndex] = useState(0)

    const {
        supremeCourtSession,
        setSupremeCourtSession,
        financialOmbudsmanSession,
        setFinancialOmbudsmanSession,
        knowledgeBaseItems,
        saveSupremeCourtConversation,
        saveFinancialOmbudsmanConversation,
        clearSupremeCourtSession,
        clearFinancialOmbudsmanSession,
        handleDeleteItem,
        handleDownloadItem,
        handleViewItem,
    } = useKnowledgeBase(setSelectedTabIndex)

    const tabs = [
        {
            title: 'Supreme Court',
            panel: (
                <SpecializedChatbot
                    session={supremeCourtSession}
                    setSession={setSupremeCourtSession}
                    onSaveConversation={saveSupremeCourtConversation}
                    onClearSession={clearSupremeCourtSession}
                    chatbotType="supreme-court"
                    title="SCJ Assistant"
                    welcomeMessage="Welcome to the Supreme Court Judgements Assistant! Ask me anything about Supreme Court cases, rulings, and legal precedents."
                    placeholder="Ask about Supreme Court judgements and precedents..."
                />
            ),
        },
        // {
        //     title: 'Financial Ombudsman',
        //     panel: (
        //         <SpecializedChatbot
        //             session={financialOmbudsmanSession}
        //             setSession={setFinancialOmbudsmanSession}
        //             onSaveConversation={saveFinancialOmbudsmanConversation}
        //             onClearSession={clearFinancialOmbudsmanSession}
        //             chatbotType="financial-ombudsman"
        //             title="Financial Ombudsman Assistant"
        //             welcomeMessage="Welcome to the Financial Ombudsman Assistant! Ask me about financial services complaints, decisions, and dispute resolutions."
        //             placeholder="Ask about financial ombudsman cases and decisions..."
        //         />
        //     ),
        // },
        {
            title: 'Stored Items',
            panel: (
                <StoredItems
                    items={knowledgeBaseItems}
                    onView={handleViewItem}
                    onDownload={handleDownloadItem}
                    onDelete={handleDeleteItem}
                />
            ),
        },
    ]

    return (
        <div className={styles.knowledgeBaseView}>
            <div className={styles.outerKnowledgeBaseContainer}>
                <div className={styles.knowledgeBaseContainer}>
                    <h2>Legal Knowledge Base</h2>
                    <TabsBlock tabs={tabs} selectedIndex={selectedTabIndex} onSelect={setSelectedTabIndex} />
                </div>
            </div>
        </div>
    )
}
